module.exports = __webpack_public_path__ + "static/media/chenjiajia.1576a9a9.png";